export default __webpack_public_path__ + "assets/images/221e989226ab84a478a99b48a4b7eeb1.png";